
$( function() {
  const header = document.getElementById( 'site-header' );
  const burger = header.querySelector('.burgerBun');
  const menu = header.querySelector( '.menu-primary-menu-container' );

  burger.addEventListener( 'click', () => {
    burger.classList.toggle( 'open' );
    menu.classList.toggle( 'open' );
  } )

  menu.querySelectorAll( '.menu-item' ).forEach( link => {
    link.addEventListener( 'click', () => {
      burger.classList.remove( 'open' );
      menu.classList.remove('open');
    })
  })

  window.addEventListener( 'scroll', headerState );
  window.addEventListener( 'resize', headerState );
  headerState();

  function headerState() {
    window.scrollY > 5 ? header.classList.add( 'scroll' ) : header.classList.remove( 'scroll' );
  }
} );
